/* eslint-disable import/extensions */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
import 'normalize.css/normalize.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import AppRouter from './routers/AppRouter';
import configureStore from './app/store/configureStore';
import initialization from './app/initialization';
import { loadSettings } from './app/store/actions/settings';

import './styles/styles.scss';

const store = configureStore();

const initRender = async () => {
  initialization(store);

  const jsx = (
    <Provider store={store}>
      <AppRouter />
    </Provider>
  );

  ReactDOM.render(jsx, document.getElementById('app'));
}

initRender();
